<app-auth-shell>
  <form class="auth-card" (ngSubmit)="onSubmit()">
    <div class="auth-card__header">
      <span class="auth-card__ornament" aria-hidden="true">⟡ ❖ ⟡</span>
      <h1>Create Account</h1>
      <p>Join Amaalmomineen and strengthen your Imaan</p>
    </div>

    <div class="auth-card__row">
      <div class="auth-card__field">
        <label for="register-name">Full Name</label>
        <div class="auth-card__input-wrapper">
          <span aria-hidden="true">👤</span>
          <input id="register-name" type="text" name="fullName" placeholder="Enter your full name" [(ngModel)]="fullName" required />
        </div>
      </div>

      <div class="auth-card__field">
        <label for="register-email">Email Address</label>
        <div class="auth-card__input-wrapper">
          <span aria-hidden="true">✉️</span>
          <input id="register-email" type="email" name="email" placeholder="Enter your email address" [(ngModel)]="email" required />
        </div>
      </div>
    </div>

    <div class="auth-card__field">
      <label for="register-password">Password</label>
      <div class="auth-card__input-wrapper">
        <span aria-hidden="true">🔒</span>
        <input
          id="register-password"
          [type]="passwordVisible() ? 'text' : 'password'"
          name="password"
          placeholder="Create a password"
          [(ngModel)]="password"
          required
        />
        <button type="button" class="auth-card__eye-toggle" (click)="togglePasswordVisibility()" [attr.aria-label]="passwordVisible() ? 'Hide password' : 'Show password'">
          {{ passwordVisible() ? '🙈' : '👁️' }}
        </button>
      </div>
      <ul class="auth-card__requirements">
        <li [class.auth-card__requirement--met]="hasMinLength()">
          <span aria-hidden="true">{{ hasMinLength() ? '✅' : '⭕' }}</span> 8+ characters
        </li>
        <li [class.auth-card__requirement--met]="hasNumber()">
          <span aria-hidden="true">{{ hasNumber() ? '✅' : '⭕' }}</span> One number
        </li>
        <li [class.auth-card__requirement--met]="hasSpecialChar()">
          <span aria-hidden="true">{{ hasSpecialChar() ? '✅' : '⭕' }}</span> One special character
        </li>
      </ul>
    </div>

    <div class="auth-card__field">
      <label for="register-confirm-password">Confirm Password</label>
      <div class="auth-card__input-wrapper">
        <span aria-hidden="true">🔒</span>
        <input
          id="register-confirm-password"
          [type]="confirmPasswordVisible() ? 'text' : 'password'"
          name="confirmPassword"
          placeholder="Confirm your password"
          [(ngModel)]="confirmPassword"
          required
        />
        <button
          type="button"
          class="auth-card__eye-toggle"
          (click)="toggleConfirmPasswordVisibility()"
          [attr.aria-label]="confirmPasswordVisible() ? 'Hide password' : 'Show password'"
        >
          {{ confirmPasswordVisible() ? '🙈' : '👁️' }}
        </button>
      </div>
    </div>

    <div class="auth-card__field">
      <label>Phone Number</label>
      <app-country-phone-input
        [(country)]="country"
        [(phoneNumber)]="phoneNumber"
        placeholder="Enter your phone number"
      ></app-country-phone-input>
    </div>

    <label class="auth-card__terms">
      <input type="checkbox" name="agreedToTerms" [(ngModel)]="agreedToTerms" required />
      <span>I agree to the <a href="#">Terms &amp; Conditions</a> and <a href="#">Privacy Policy</a></span>
    </label>

    @if (errorMessage()) {
      <p class="auth-card__error" role="alert">{{ errorMessage() }}</p>
    }

    <button type="submit" class="auth-card__submit" [disabled]="loading() || !agreedToTerms()">
      <span aria-hidden="true">➕👤</span>
      {{ loading() ? 'Creating account…' : 'Create Account' }}
    </button>

    <div class="auth-card__divider">
      <span>or sign up with</span>
    </div>

    <div class="auth-card__social">
      <button type="button" class="auth-card__social-btn">
        <span class="auth-card__social-icon auth-card__social-icon--google" aria-hidden="true">G</span>
        Google
      </button>
      <button type="button" class="auth-card__social-btn">
        <span aria-hidden="true">🍎</span>
        Apple
      </button>
    </div>

    <p class="auth-card__footer-link">
      Already have an account? <a [routerLink]="routes.AUTH.LOGIN">Login</a>
    </p>
  </form>
</app-auth-shell>
